import {combineReducers, Reducer} from 'redux'
import { VideoContentState } from '@models/video-content'
import {VideoContentsActionTypes} from '@actions/video-content';




// Type-safe initialState!
export const initialState: VideoContentState = {
    allIds:[],
    byId:{},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) =>{
    switch(action.type){
        case VideoContentsActionTypes.FETCH_SUCCESS:{
            const{ data} = action.payload;
            return {
                ...data.reduce( (obj, video) => {
                    obj[video.id] = {
                        ...video,
                        is_fetched: false,
                        ...(state[video.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case VideoContentsActionTypes.CREATE_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : video
            };
        }

        case VideoContentsActionTypes.UPDATE_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : {
                    ...state[video.id],
                    ...video
                }
            };
        }

        case VideoContentsActionTypes.FETCH_ITEM_SUCCESS:{
            const video = action.payload;
            return {
                ...state,
                [video.id] : {
                    ...state[video.id],
                    ...video,
                    is_fetched: true
                },
            };
        }

        case VideoContentsActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case VideoContentsActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map( item  => item.id);
        }

        case VideoContentsActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case VideoContentsActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case VideoContentsActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case VideoContentsActionTypes.DELETE_SUCCESS:
            return state - 1;

        case VideoContentsActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case VideoContentsActionTypes.FETCH_REQUEST: {
            return true;
        }

        case VideoContentsActionTypes.FETCH_SUCCESS:
        case VideoContentsActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<VideoContentState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export { reducer as videoContentReducer }




//Selectors
export const getVideoContentsList = videoContents => videoContents.allIds.map( id => videoContents.byId[id]);

export const getVideoContentById = (videoContents, id) => videoContents.byId[id];